import React, { useEffect } from 'react';
import { SiteWideNotice } from '../../reusablePartials';
import {
	Overview,
	RadarChart,
	RangeChart,
	Level1OverviewChart,
	DataTable,
	SubjectBarGraph,
	ModalRadarInformation,
	DriversOfChanges,
} from './partials';
import { getUrlQueryParams } from '../../actions';
import { useAppPipeline } from '../../hooks';
import styles from './styles.css';
import { useAppContext } from '../../context/AppState.jsx';
import { useModalContext } from '../../context/modalContext.jsx';
import { LoadingSpinner } from '../../components';

const getSelectedLocation = () => {
	return window.location_detailed_info;
};

export default function Layout() {
	const [state, dispatch] = useAppContext();
	const [showModal] = useModalContext();
	const urlParams = getUrlQueryParams();
	useAppPipeline({ urlParams });

	const selectedLocation = getSelectedLocation();

	useEffect(() => {
		dispatch({
			type: 'selectedLocation',
			payload: selectedLocation,
		});
		dispatch({
			type: 'selectedSubject',
			payload: 'GOVERNANCE',
		});
	}, [state.setUrlQueryParam]);

	if (!state?.indexedYml) {
		return (
			<div className="uk-grid uk-grid-small uk-grid-match">
				<div className={`uk-width-1-1`}>
					<div className={styles.backgroundWhite}>
						<LoadingSpinner />
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="uk-grid uk-grid-small uk-grid-match">
				<div className={`uk-width-1-1`}>
					<div className={styles.backgroundWhite}>
						<Overview state={state} />
					</div>
				</div>

				<div className={`uk-width-1-2@m`}>
					<div className={styles.backgroundWhite}>
						<Level1OverviewChart />
					</div>
				</div>
				<div className={`uk-width-1-2@m`}>
					<div className={styles.backgroundWhite}>
						<span
							onClick={() => showModal(<ModalRadarInformation />)}
							className={`uk-icon-information uk-icon ${styles.infoIcon}`}
							uk-icon="info"
						/>
						<RadarChart />
					</div>
				</div>
				<div className={`uk-width-2-5@m`}>
					<div className={styles.backgroundWhite}>
						<RangeChart state={state} />
					</div>
				</div>
				<div className={`uk-width-3-5@m`}>
					<div className={styles.backgroundWhite}>
						<DataTable state={state} />
					</div>
				</div>
				<div className={`uk-width-1-1@m`}>
					<div className={styles.backgroundWhite}>
						<SubjectBarGraph state={state} />
					</div>
				</div>
				<div className={`uk-width-1-1@m`}>
					<div className={styles.backgroundWhite}>
						<DriversOfChanges state={state} dispatch={dispatch} />
					</div>
				</div>
			</div>
			<SiteWideNotice />
		</>
	);
}
